<template>
    <div 
        class="m-extreme-point extreme-point"
        :class="[
            {'m-extreme-point extreme-point--disabled': disabled},
            {'m-extreme-point__cursor-pointer': isComponentClickable},
            `extreme-point--${theme}`]"
        @click="conditionalHandleActivate"
    >
        <div
            class="extreme-point__point"
        >
            <svg-icon
                v-if="pointIcon"
                original
                :name="`icons/${theme}`"
                class="extreme-point__icon"
            />
            <span class="extreme-point__point-text">
                {{ label }}
            </span>
        </div>
        <label
            :for="`extremePointInput${label}`"
            v-if="inputElement"
            class="extreme-point-input-label"
        >
            <span class="extreme-point-input-label__hide-text">{{`Extreme point input ${label}`}}</span>
            <input
                :id="`extremePointInput${label}`"
                :aria-label="ariaLabel"
                ref="extremePointInput"
                type="text"
                class="extreme-point__input"
                :value="localValue"
                :disabled="disabled"
                :placeholder="placeholder"
                @blur="handleBlur"
                @click="handleActivate"
                @keyup.enter="handleActivate"
                @input="handleChange($event.target.value)"
            >
        </label>
        <span
            v-else
            class="extreme-point__input"
            @click="handleActivate"
            v-html="localValue"
        >
        </span>
        <AMItemsCloseButton
            v-if="localValue && clearable && !disabled"
            class="extreme-point__clear-button"
            @onClick="clearValue"
        />
        <svg-icon
            v-else-if="!localValue && searchbale"
            original
            name="icons/search-red"
            class="extreme-point__search-icon"
        />
        <svg-icon
            v-if="editIcon"
            original
            name="icons/edit"
            class="extreme-point__edit-icon"
            @click="handleActivate"
        />
    </div>
</template>

<script>
import AMItemsCloseButton from '../../atoms/a-m-items-close-button/a-m-items-close-button';

import hyphensWords from '../../../utils/mixins/hyphens-words'
    
export default {
    name: 'MExtremePoint',
    components: {
        AMItemsCloseButton
    },
    mixins: [hyphensWords],
    props: {
        theme: {
            type: String,
            default: 'start',
            validator: val => ['start', 'finish'].includes(val)
        },
        label: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: ''
        },
        clearable: {
            type: Boolean,
            default: false
        },
        searchbale: {
            type: Boolean,
            default: false
        },
        ariaLabel: {
            type: String,
            default: 'Extreme point input'
        },
        editIcon: {
            type: Boolean,
            default: false
        },
        pointIcon: {
            type: Boolean,
            default: true
        },
        inputElement: {
            type: Boolean,
            default: true
        },
        isComponentClickable: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        print: false
    }),
    computed: {
        localValue: {
            get() {
                if(this.print) return this.value;
                else return this.hyphensWords(this.value);
            },
            set(e) {
                this.$emit('input', e)
            }
        }
    },
    methods: {
        initEventListeners() {
            window.addEventListener("beforeprint", this.changePrintMode);
            window.addEventListener("afterprint", this.changePrintMode);
        },
        deactivateEventsListeners() {
            window.removeEventListener("beforeprint", this.changePrintMode);
            window.removeEventListener("afterprint", this.changePrintMode);
        },
        handleActivate() {
            this.$emit('onActivate', true);
        },
        conditionalHandleActivate() {
            if(this.isComponentClickable) this.handleActivate()
        },
        handleBlur() {
            this.$emit('onBlur', true);
        },
        handleChange(value) {
            this.localValue = value;
            this.$emit('onChange', value);
        },
        clearValue() {
            this.localValue = '';
            this.$refs.extremePointInput.focus();
            this.$emit('onClear', true);
        },
        changePrintMode() {
            this.print = !this.print;
        },
    },
    mounted() {
        this.initEventListeners();
    },
    beforeDestroy() {
        this.deactivateEventsListeners();
    },
}
</script>

<style lang="scss">
@import "m-extreme-point";    
</style>